import { removeKeyFromState } from '../../util/reducers'
import { CLEAR_API_ERROR, SET_API_ERROR } from './actions'

export function apiErrors(state = {}, action) {
  const { httpMethod, route, key, error } = action

  switch (action.type) {
    case SET_API_ERROR:
      return {
        ...state,
        [httpMethod]: {
          ...state[httpMethod],
          [route]: {
            ...(state[httpMethod] ? state[httpMethod][route] : {}),
            [key]: error,
          },
        },
      }
    case CLEAR_API_ERROR:
      return removeError(state, action)
    default:
      return state
  }
}

const removeError = (state, action) => {
  const { httpMethod, route, key } = action
  let newState = removeKeyFromState(state[httpMethod][route], key)
  if (Object.keys(newState).length) {
    return {
      ...state,
      [httpMethod]: newState,
    }
  } else {
    newState = removeKeyFromState(state[httpMethod], route)
    if (Object.keys(newState).length) {
      return {
        ...state,
        [httpMethod]: newState,
      }
    } else {
      return removeKeyFromState(state, httpMethod)
    }
  }
}
